<template>
  <div class="community_outer">
    <div class="community_container" @click="clickShowPointDetail">
      <div class="c_left">
        <img :src="myData.url" class="c_l_img"/>
        <p class="left_match" v-if="!isExport" :style="{background: bkColor}">{{ showMatchRate }}</p>
      </div>
      <div class="c_row_1">
        <span class="c_name">{{ myData.name }}</span>
        <span class="c_address">{{ myData.location }}</span>
        <template v-if="showByte && !isActionUser">
          <div class="c_bytes" v-if="showHours" @click.stop="goBytes"><img :src="bytesClick" /><span>实时流量</span></div>
          <div class="c_bytes grey" v-else @click.stop="showTips=true"><img :src="bytes" /><span>实时流量</span></div>
        </template>
      </div>
      <div class="c_row_2 label_groups">
        <div class="label_item" v-if="myData.place_type">{{ myData.place_type }}</div>
        <div class="label_item">房屋均价：￥{{ myData.housesPrice | toFixed2 }}/㎡</div>
        <div class="label_item">物业费：{{ acStr('maintenanceCharge', '/㎡', '￥') }}</div>
        <div class="label_item">{{ buh }}</div>
        <template v-if="isCpm || cprPlus">
          <div class="label_item">工作日流量：{{ acStr('workdayAdvFr', '人次/天') }}</div>
          <div class="label_item">节假日流量：{{ acStr('holidayAdvFr', '人次/天') }}</div>
        </template>
      </div>
      <div class="c_row_3">
        <template v-if="payWay != 'cpmL'">
          <span class="color_default">总价：</span>
          <span class="color_primary mg20">￥<i class="num_font">{{ myData.allSelectSlotAmount | toFixed2 }}</i></span>
        </template>

        <template v-if="isSmallSn">
          <p class="mg20">
            <span class="color_default">单价：</span>
            <span class="color_primary">￥<i class="num_font">{{ myData.price | toFixed2 }}</i></span>{{feeUnit}}
          </p>
        </template>
        <template v-else>
          <p class="mg20">
            <template>梯内：</template>
            <template v-if="myData.price">
              <span class="color_primary">￥<i class="num_font">{{ myData.price }}</i></span>{{feeUnit}}
            </template>
            <template v-else>暂无</template>
          </p>
          <p class="mg20">
            <template>梯外：</template>
            <template v-if="myData.price">
              <span class="color_primary">￥<i class="num_font">{{ myData.twPrice }}</i></span>{{feeUnit}}
            </template>
            <template v-else>暂无</template>
          </p>
        </template>

        <span class="c_r_right"><span class="color_default">
          已选屏幕：</span><span class="color_primary num_font">{{ myData.allSelectDeviceCount }}</span>
          /<i class="num_font">{{ myData.allDeviceCount }}</i><i class="iconfont icon-qiehuanyou"></i>
        </span>
      </div>
    </div>
    <SelectCommunityDevice ref="SelectCommunityDevice" @change="deviceCheckChange"></SelectCommunityDevice>
    <el-dialog
      class="tips"
      title="温馨提示"
      :visible.sync="showTips"
      width="30%"
      center>
      <span>系统正在休息，请早上7点后再来查看～</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showTips = false">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import bytes from '@/assets/bytes.png'
import bytesClick from '@/assets/bytes_click.png'
export default {
  name: 'MyCommunityInfo',
  components: {
    SelectCommunityDevice: () => import('../dialog/SelectCommunityDevice')
  },
  filters: {
    toFixed2 (nv) {
      return nv ? new Number(nv).toFixed(2) : 0
    }
  },
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    isExport: {
      type: Boolean, default: false
    },
    showByte: {
      type: Boolean, default: false
    },
    smartSortType: {
      type: String, default: ''
    }
  },
  data () {
    return {
      bytes,
      bytesClick,
      showTips: false,
      hours: moment().format('H'),
      matchColor: ['#B59A9A', '#B59A9A', '#C88290', '#DB6A87', '#ED527D', '#FF3973']
    }
  },
  computed: {
    isActionUser() {
      let userInfo = this.$store.state.customer.userInfo
      return userInfo && userInfo.id == 2000831
    },
    bkColor () {
      if(this.smartSortType == 3) return '#FF3973' // 流量密度只展示红色
      let { match, emptySaleRate } = this.myData // 推荐度 空刊率
      let data
      if (this.isCondition && this.smartSortType == 2) {
        emptySaleRate = (emptySaleRate || 0 - 0) * 100
        data = Math.floor(emptySaleRate / 20) + 1
        if (data == 6) data = 5
      } else {
        match = (match || 0 - 0) * 100
        data = Math.ceil(match / 20)
      }
      return this.matchColor[data]
    },
    showMatchRate () { // 条件筛选 空刊优先时 显示范围数据  不展示具体信息 ≥ 最接近它的 20  40  60 。。。
      let { match, emptySaleRate, flowPerPoint } = this.myData // 推荐度 空刊率
      match = (match || 0 - 0) * 100
      if (!this.isCondition) return `推荐度:${match.toFixed(0)}%` // 非条件搜索 展示推荐度
      if (this.smartSortType == 2) { // 空刊优先 2 展示空刊率的模糊值
        emptySaleRate = (emptySaleRate || 0 - 0) * 100
        let more = emptySaleRate % 20
        let data = emptySaleRate - more
        // return `空刊率≥${data === 100 ? 80 : data}%`
        let res = 0
        if (more === 0) {
          res = data
        } else {
          res = data + 20
        }
        return `空刊率≤${res}%`
      } else if (this.smartSortType == 3) {
        return `${flowPerPoint || 0}人/屏/天`
      }
      return `推荐度:${match.toFixed(0)}%` // 非空刊展示推荐度
    },
    showHours () {
      if (this.hours >= 7 || this.hours < 1) return true
      return false
    },
    buh () {
      let { buildingNumber, unitNumber, housesNumber } = this.myData
      return `${ buildingNumber || 0 }栋楼-${ unitNumber || 0 }单元` + (housesNumber && housesNumber > -1 ? '-' + housesNumber + '户' : '')
    },
    payWay () {
      return this.$store.state.order.choosePayWay // 'cpd', 'cpmL', 'cpmT'
    },
    cprPlus () {
      return this.$store.state.order.form.orderType === 6005
    },
    isCpd () {
      return !this.payWay || this.payWay == 'cpd'
    },
    acStr () { // 权限展示
      return (key, appendStr, preStr) => {
        let data = this.myData[key]
        return data == -1 ? '--' : (data === null || data === undefined ? '暂无数据' : (preStr || '') + data + (appendStr || ''))
      }
    },
    isCpm () {
      return this.payWay == 'cpmL' || this.payWay == 'cpmT'
    },
    feeUnit () {
      return this.isCpm ? '/千人次' : '/屏/天'
    },
    myData: {
      get () {
        Object.keys(this.data).forEach(el => {
          this.$set(this.data, el, this.data[el])
        })
        return this.data
      },
      set (nv) {
        this.$emit('update:data', nv)
      }
    },
    isSmallSn () { // 是否是小屏投放或小屏导入点位
      let name = this.$store.state.order.conditionSearchTypeName
      return name.toLowerCase().indexOf('smallsn') > -1
    },
    isCondition () { //是否是条件筛选
      return this.$store.state.order.conditionSearchTypeName == 'putOrder'
    }
  },
  methods: {
    goBytes () {
      let { guid, name } = this.myData
      this.$emit('showSight', { id: guid, name })
    },
    clickShowPointDetail () {
      this.$refs.SelectCommunityDevice.show(this.myData, this.isExport)
    },
    deviceCheckChange (data) {
      this.myData.buildDeviceList = data.buildDeviceList
      this.myData.twBuildDeviceList = data.twBuildDeviceList
      this.myData.tnSelectSlotAmount = data.tnSelectSlotAmount
      this.myData.tnSelectDeviceCount = data.tnSelectDeviceCount
      this.myData.twSelectSlotAmount = data.twSelectSlotAmount
      this.myData.twSelectDeviceCount = data.twSelectDeviceCount
      let checkDevices = data.allDevices.filter(el => el.check)
      this.myData.allSelectSlotAmount = checkDevices.reduce((res, cur) => res += this.isCpm ? cur.flowAmount || 0 : cur.amount || 0, 0)
      this.myData.allSelectDeviceCount = checkDevices.length
      this.myData.allDevices = data.allDevices
      this.myData.checked = checkDevices.length == data.allDevices.length

      this.$emit('change', this.myData)
    }
  }
}
</script>

<style lang="scss" scoped>
.tips {
  ::v-deep .el-dialog {
    border-radius: 8px;
  }
  ::v-deep .el-dialog__body {
    line-height: 110px;
    text-align: center;
  }
  ::v-deep .el-dialog__body {
    height: 180px;
    border-top: 1px solid #E9E9E9;
    border-bottom: 1px solid #E9E9E9;
  }
}
.community_outer {
  display: inline-block;
}
.community_container {
  display: grid;
  grid-template-columns: 90px auto;
  grid-template-rows: 22px auto 20px;
  grid-column-gap: 10px;
  margin: 15px 0;
}
.c_left {
  grid-row: 1 / 4;
  .left_match {
    position: relative;
    z-index: 1;
    height: 16px;
    border-width: 0 1px 1px;
    border-style: solid;
    border-color: #eee;
    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 16px;
    text-align: center;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    margin-top: -16px;
  }
}
.c_l_img {
  display: block;
  width: 90px;
  height: 90px;
  border-radius: 4px;
  border: 1px solid #eee; // delete
}
.c_row_1 {
  .c_name {
    color: #282729;
    font-size: 16px;
    line-height: 22px;
  }
  .c_address {
    padding: 2px 0 3px 10px;
    color: #999999;
    font-size: 12px;
    line-height: 17px;
  }
  .grey {
    color: #D4D4D4;
  }
  .c_bytes {
    float: right;
    font-size: 12px;
    padding-right: 20px;
    cursor: pointer;
    img {
      position: relative;
      top: 1px;
      left: -3px;
    }
  }
}
.label_groups {
  padding: 6px 0;
  .label_item {
    display: inline-block;
    padding: 4px 8px 3px;
    margin: 4px 4px 4px 0;
    color: #666;
    line-height: 17px;
    font-size: 12px;
    background-color: #f5f5f5;
    border-radius: 4px;
    &:not(:first-child) {
      // margin-left: 4px;
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
.c_row_3 {
  color: #282729;
  font-size: 14px;
  font-family: Akrobat;
  line-height: 20px;
  .c_r_right {
    // margin-left: 20px;
  }
  .mg20 {
    display: inline-block;
    // margin-left: 20px;
    margin-right: 20px;
  }
  .num_font {
    font-size: 16px;
    font-weight: bolder;
  }
}
.color_default {
  color: #999999;
}
.color_primary {
  color: #FF3973;
}
.icon-qiehuanyou {
  color: #282729;
  font-size: 12px;
  margin-left: 10px;
}
</style>


